import { render, staticRenderFns } from "./PublicOld.vue?vue&type=template&id=48eca599&scoped=true&"
import script from "./PublicOld.vue?vue&type=script&lang=ts&"
export * from "./PublicOld.vue?vue&type=script&lang=ts&"
import style0 from "./PublicOld.vue?vue&type=style&index=0&id=48eca599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eca599",
  null
  
)

export default component.exports